import { Injectable } from "@angular/core";

import * as CryptoJS from 'crypto-js';
@Injectable()


export class S3BudgetService {
    public awsS3BugetURL = 'https://s3.ap-south-1.amazonaws.com/';

    public defaultKey = "dhgjdhyruieHHgdjIOeNmjfhuyeisjsj";
    s3GetFile(params: any) {
        return new Promise((resolve, reject) => {
            try {
                console.log('GET S3 Budget')
                let url = this.awsS3BugetURL + params.Bucket;
                console.log('URL ', url);
                fetch(url, {
                    method: 'POST',
                    headers: { "Access-Control-Allow-Origin": "*" }
                }).then(response => response.json()).then(data => console.log('*****-->>>> ', data));
                // const oReq = new XMLHttpRequest();
                // oReq.open('GET', url, true);
                // // oReq.responseType = 'arraybuffer';
                // oReq.onload = function(oEvent) {
                //     const arrayBuffer = oReq.response; // Note: not oReq.responseText
                //     console.log('arrayBuffer----> ', arrayBuffer)
                // }
                // oReq.onerror = function(e) {
                //     console.log('onErro', e);
                // };
                // oReq.send(null);

            } catch (error) {
                console.log('Error ', error);
            }
        });
    }
    set(keys, value) {
        keys = this.defaultKey;
        var key = CryptoJS.enc.Utf8.parse(keys);
        var iv = CryptoJS.enc.Utf8.parse(keys);
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

        return encrypted.toString();
    }
    encrypt(text, customKey = "") {
        // ------------  ********  -------------------
        const defaultKey = this.defaultKey;
        // const key32 = (customKey + defaultKey).slice(0, 32),
        //   key16 = key32.slice(0, 16);
        // var cipher = CryptoJS.createCipheriv('aes-256-cbc',
        //   Buffer.from(key32), Buffer.from(key16))
        // var crypted = cipher.update(text, 'utf8', 'hex')
        // crypted += cipher.final('hex')
        // return crypted;

        //     var key = CryptoJS.enc.Utf8.parse(this.defaultKey);
        // var iv = CryptoJS.enc.Utf8.parse(this.defaultKey);
        // var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
        // {
        //     keySize: 128 / 8,
        //     iv: iv,
        //     mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        // });

        // return encrypted.toString();
        //   }
        // ------------- ******** ------------------
    }

    s3GetAudio(url: any) {
        return new Promise((resolve, reject) => {
            try {
                // console.log('GET S3 Budget')
                // console.log('URL ', url);
                fetch(url)
                .then((response) => {
                //   return response.json();
                  return response.text();
                })
                .then((myJson) => {
                //   console.log("hi", myJson);
                  resolve(myJson);
                });

                // fetch(url, {
                //     method: 'POST',
                //     // headers: { "Access-Control-Allow-Origin": "*" }
                // }).then(response => response.json()).then(data => console.log('*****-->>>> ', data));
            } catch (error) {
                console.log('Error ', error);
            }
        });
    }


}